import { useTranslation } from 'next-i18next';
import { type CategoryDisplayText } from '@/views/build/features/category-display-text';
import { type CategorySelectorState, PlainSelection } from '@/views/build/features/category-select-view';
export const SchoolTypeSelection = ({
  categoryInfo,
  displayText
}: {
  categoryInfo: CategorySelectorState;
  displayText: CategoryDisplayText;
}) => {
  const {
    t
  } = useTranslation(['build']);
  return <PlainSelection label={t('build:schoolInfo.schoolLevel')} value={categoryInfo.schoolType.selectedSchoolTypeNode} options={categoryInfo.schoolType.schoolInfoNodes} error={categoryInfo.errors.schoolTypeId} isActive={true} onChange={categoryInfo.updateCategoryInfo} onHover={value => {
    displayText.updateHoverPreview({
      field: 'schoolTypeId',
      value: value.groupId,
      label: value.label
    });
  }} onHoverLeave={() => {
    displayText.clearHoverPreview('schoolTypeId');
  }} data-sentry-element="PlainSelection" data-sentry-component="SchoolTypeSelection" data-sentry-source-file="SchoolTypeSelection.tsx" />;
};